<template>
    <v-layout style = 'flex: 0 0 auto !important;'>
        <dialog-generic 
            :visibility.sync = 'visibility' 
            :indicator = 'indicator'
            :min-width = '$vuetify.breakpoint.smAndUp ? "65%": "95%"'
            max-width = '95%'
        >
            <template v-slot:title>Мультипликаторы расходов</template>
            <template v-slot:content>
                <v-layout column align-center justify-center style = 'height: 350px;' v-show = 'indicator'>
                    <v-progress-circular indeterminate :color = '$store.getters.uiAccent' size = '32' width = '1'></v-progress-circular>
                </v-layout>
                <v-layout column v-show = '!indicator'>
                    <v-data-table
                        :headers = 'headers'
                        :items = 'factors'
                        sort-by = 'source_type_id'
                    >
                        <template v-slot:item.action = "{ item }">
                            <v-btn icon small @click = 'cursorFactor = item; edit = true; dialogs.update = true;'>
                                <v-icon small color='light-blue darken-1'>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn icon small @click = 'cursorFactor = item; dialogs.delete = true;'>
                                <v-icon small :color='$store.getters.uiAccentIcon'>mdi-delete-outline</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:body.append>
                            <tr @click = 'cursorFactor = {}; edit = false; dialogs.update = true;'>
                                <td :colspan = "headers.length">Добавить мультипликатор</td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-layout>
            </template>
        </dialog-generic>
        <dialog-generic 
            :visibility.sync = 'dialogs.delete' 
            :indicator = 'indicator'
        >
            <template v-slot:title>Удаление мультипликатора</template>
            <template v-slot:content>
                <div class = 'py-3 mx-auto text-center'>Удалить мультипликатор для <b>{{cursorFactor.source_type_id}}</b>?</div>
            </template>
            <template v-slot:action>
                <v-btn class = 'px-0 red--text text--darken-2' :loading = 'indicator' block depressed @click = 'deleteFactor'>Удалить</v-btn>
            </template>
        </dialog-generic>
        <dialog-generic 
            :visibility.sync = 'dialogs.update' 
            :indicator = 'indicator'
            max-width = '620px'
        >
            <template v-slot:title>Мультипликатор</template>
            <template v-slot:content>
                <v-form v-model = 'factorValid'>
                    <v-container>
                        <v-row justify = 'center'>
                            <v-col cols="12" sm="6" md="4">
                                <v-select
                                    v-model="cursorFactor.source_type_id" 
                                    :items = 'source_type_ids'
                                    :disabled = 'edit'
                                    label = "Источник"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select
                                    v-model="cursorFactor.factor_type" 
                                    :items = 'types'
                                    label="Тип"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row justify = 'center'>
                            <v-col cols="12" sm="6" md="4">
                                <v-menu 
                                    ref="selectedDateStart" 
                                    :close-on-content-click="false" 
                                    :return-value.sync="cursorFactor.factor_start" 
                                    offset-y 
                                    v-model='selectedDateStart'
                                >
                                    <template v-slot:activator = '{ on }'>
                                        <v-text-field 
                                            v-on = 'on' 
                                            v-model='cursorFactor.factor_start' 
                                            readonly 
                                            required label='Применяется с'
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker 
                                        :rules="[rules.required]" 
                                        style = 'width: 100%;' 
                                        :header-color = '$store.getters.uiAccent' 
                                        v-model = 'cursorFactor.factor_start' 
                                        @input = "$refs.selectedDateStart.save(cursorFactor.factor_start)" 
                                        locale='ru-ru' min='2018-01-01' 
                                        first-day-of-week='1'
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-menu 
                                    ref="selectedDateEnd" 
                                    :close-on-content-click="false" 
                                    :return-value.sync="cursorFactor.factor_end" 
                                    offset-y 
                                    v-model='selectedDateEnd'
                                >
                                    <template v-slot:activator = '{ on }'>
                                        <v-text-field 
                                            v-on = 'on' 
                                            v-model = 'cursorFactor.factor_end' 
                                            readonly 
                                            required label='Применяется по'
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker 
                                        :rules="[rules.required]" 
                                        style = 'width: 100%;' 
                                        :header-color='$store.getters.uiAccent' 
                                        v-model='cursorFactor.factor_end' 
                                        @input="$refs.selectedDateEnd.save(cursorFactor.factor_end)" 
                                        locale='ru-ru'
                                        first-day-of-week='1'
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row justify = 'center'>
                            <v-col cols="12" sm="12" md="8">
                                <v-text-field
                                    :rules = '[rules.numeric]'
                                    v-model="cursorFactor.factor" label="Значение"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </template>
            <template v-slot:action>
                <v-btn 
                    class = 'px-0 light-blue--text text--darken-2' 
                    :loading = 'indicator' 
                    :disabled = '!factorValid' 
                    block depressed 
                    @click = 'createOrUpdateFactor'
                >Применить</v-btn>
            </template>
        </dialog-generic>
    </v-layout>
</template>

<script>

    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'
    import projectHandlers from '@/mixins/project'
    import { orderBy } from 'lodash-es'

    export default {
        name: 'ProjectFactors',
        props: ['initialState', 'data'],
        mixins: [projectHandlers],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                factors: [],
                project: this.data,
                visibility: this.initialState,
                indicator: false,
                edit: false,
                dialogs: {
                    update: false,
                    delete: false
                },
                factorValid: false,
                headers: [{
                    text: 'Источник',
                    align: 'left',
                    sortable: true,
                    value: 'source_type_id'
                }, {
                    text: 'Тип',
                    align: 'center',
                    sortable: true,
                    value: 'factor_type'
                }, {
                    text: 'Применяется с',
                    align: 'center',
                    sortable: true,
                    value: 'factor_start'
                }, {
                    text: 'Применяется по',
                    align: 'center',
                    sortable: true,
                    value: 'factor_end'
                }, {
                    text: 'Значение',
                    align: 'center',
                    sortable: true,
                    value: 'factor'
                }, {
                    text: 'Действия',
                    value: 'action',
                    sortable: false
                }],
                cursorFactor: {},
                types: ['fee'],
                selectedDateStart: false,
                selectedDateEnd: false,
                rules: {
                    required: value => !!value || 'Обязательное поле.',
                    numeric: value => /^[0-9.-]+$/.test(value) && (value >= -1 && value <= 1) || 'Введите число от 0 до 1 с разделителем точка (.)'
                }
            }
        },
        computed: {
            source_type_ids() {
                const ids = this.$store.state.sourceTypes
                return ids.filter(s => s.source_type_meaning == 'ad_cabinet').map(s => s.source_type_id)
            }
        },
        watch: {
            data(value) {
                this.project = value
                this.getProjectFactors()
            },
            initialState(value) {
                this.visibility = value
            },
            visibility(value) {
                this.$emit('update:initialState', value);
                if (value) {
                    this.getProjectFactors()
                }
            }
        },
        methods: {
            deleteFactor() {
                this.indicator = true;
                this.$http.patch(
                    `${this.$store.getters.endpoint}/db/project/${this.project.project_id}/factors`, {
                        login: this.$store.getters.currentUser.login,
                        factor: this.cursorFactor
                    }, {
                        headers: this.$store.state.restrictedHeaders
                }).then( (r) => {
                    this.dialogs.delete = false;
                    this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'delete',
                            target: 'project_factor'
                        },
                        once: false
                    })
                    this.getProjectFactors()
                })
            },
            updateFactor() {
                this.indicator = true;
                this.$http.put(
                    `${this.$store.getters.endpoint}/db/project/${this.project.project_id}/factors`, {
                        login: this.$store.getters.currentUser.login,
                        factor: this.cursorFactor
                    }, {
                        headers: this.$store.state.restrictedHeaders
                }).then( (r) => {
                    this.dialogs.update = false;
                    this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'update',
                            target: 'project_factor'
                        },
                        once: false
                    })
                    this.getProjectFactors()
                })
            },
            createFactor() {
                this.indicator = true;
                this.$http.post(
                    `${this.$store.getters.endpoint}/db/project/${this.project.project_id}/factors`, {
                        login: this.$store.getters.currentUser.login,
                        factor: this.cursorFactor
                    }, {
                        headers: this.$store.state.restrictedHeaders
                }).then( (r) => {
                    this.dialogs.update = false;
                    this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'create',
                            target: 'project_factor'
                        },
                        once: false
                    })
                    this.getProjectFactors()
                })
            },
            createOrUpdateFactor() {
                if (this.edit) {
                    this.updateFactor()
                } else {
                    this.createFactor()
                }
            },
            getProjectFactors() {
                this.indicator = true;
                this.getProjectPropertyPromise('factors').then((r) => {
                    let response = r.body
                    this.indicator = false
                    if (response.result) {
                        this.factors = response.data
                    } else {
                        console.log('error fetch project factors', response.data)
                    }
                });
            }
        },
        mounted() {
        }
    }
</script>